const QueryKeys = {
  list: 'streams/sites/list',
};

export default QueryKeys;
